class BaxCplpIntro extends HTMLElement {
  // Must match the mobile media query in bjornaxen-category-plp.css
  static MOBILE_QUERY = '(max-width: 749px)';

  constructor() {
    super();
    // Observing the intro rather than window resize keeps cleanup scoped to the
    // element, so Theme Editor section reloads cannot leave listeners behind.
    this.resizeObserver = window.ResizeObserver
      ? new ResizeObserver(() => this.sync())
      : null;

    this.handleToggle = () => this.toggle();
  }

  connectedCallback() {
    this.intro = this.querySelector('.bax-cplp__intro');
    this.btn = this.querySelector('.bax-cplp__intro-more');

    if (!this.intro || !this.btn) return;

    this.moreLabel = this.dataset.readMoreLabel;
    this.lessLabel = this.dataset.readLessLabel;

    this.sync();
    this.resizeObserver?.observe(this.intro);
    this.btn.addEventListener('click', this.handleToggle);

    // Web fonts can change the text height after the first sync.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (this.isConnected) this.sync();
      });
    }
  }

  disconnectedCallback() {
    this.btn?.removeEventListener('click', this.handleToggle);
    this.resizeObserver?.disconnect();
  }

  // Clamping itself is CSS-driven (mobile only). JS just decides whether the
  // toggle is needed, i.e. whether the text actually overflows 4 lines.
  sync() {
    if (!window.matchMedia(BaxCplpIntro.MOBILE_QUERY).matches) {
      this.intro.classList.remove('is-expanded');
      this.btn.hidden = true;
      this.btn.textContent = this.moreLabel;
      this.btn.setAttribute('aria-expanded', 'false');
      return;
    }

    if (this.intro.classList.contains('is-expanded')) return;

    this.btn.hidden = this.intro.scrollHeight <= this.intro.clientHeight + 1;
  }

  toggle() {
    const isExpanded = this.intro.classList.toggle('is-expanded');

    this.btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    this.btn.textContent = isExpanded ? this.lessLabel : this.moreLabel;
  }
}

if (!customElements.get('bax-cplp-intro')) {
  customElements.define('bax-cplp-intro', BaxCplpIntro);
}
